import { useRef, memo } from "react";
import { useHistory } from "react-router-dom";

import {
  StyledLogoSection,
  ViewNowMobileButton,
  StyledCommentsContainer,
  StyledHeaderText,
  WidgetContainer,
  ClipSection,
  ViewNowButton,
  ClipPlayerContainer,
  StyledTop5Logo,
} from "./styledComponents";
import { Top5PlayersList } from "./Top5PlayersList";
import { ClipComments } from "../Comments/Clip";
import { Top5WidgetViewModel } from "./ViewModel";
import { VideoPlayer } from "../../VideoPlayer";

import { analytics } from "MVVM/Analytics";
import { countClipImpression } from "MVVM/Utilities/Clip";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

const Top5Widget = memo(() => {
  const { loading, clip } = Top5WidgetViewModel();
  const videoPlayerRef = useRef(null);
  const history = useHistory();

  const trackViewNowClick = () => {
    analytics.track("Button Click", {
      button_name: "View Now",
      location: "top_5_widget",
      source: "logo_section",
    });
  };

  if (loading || !clip) return <></>;

  return (
    <WidgetContainer>
      <StyledLogoSection>
        <StyledTop5Logo
          src={`${REACT_APP_S3_CLIP_BUCKET}/static/web/top5/top5logo.png`}
          alt="Top 5 Logo"
          width={133}
        />
        <Top5PlayersList topPlayers={clip.associatedUsers} />
        <ViewNowButton
          to={`/clip/${clip.shareId}`}
          onClick={trackViewNowClick}
          $isFullWidth
        >
          Share
        </ViewNowButton>
      </StyledLogoSection>
      <ClipSection
        onClick={() => {
          trackViewNowClick();
          history.push(`/clip/${clip.shareId}`);
        }}
        $hideControlBar
      >
        <ClipPlayerContainer id="clip-player-container">
          <VideoPlayer
            refForVideoPlayer={videoPlayerRef}
            mp4Source={clip.url}
            loop={true}
            onPlayStart={() => countClipImpression(clip.shareId)}
            playAnalyticsProperties={{
              shareId: clip.shareId,
              clipId: clip.id,
              clipOwner: clip.user,
              total_views: clip.views,
              game: clip.game,
            }}
            watchAnalyticsProperties={{
              clipId: clip.id,
              collection: "Top5Widget",
              collectionType: "Widget",
              item: clip.shareId,
              itemType: "Clip",
              action: "play",
            }}
            options={{
              controls: true,
              aspectRatio: "16:9",
              poster: clip.thumbnailStandardUrl,
              playsinline: true,
              autoplay: "muted",
            }}
          />
        </ClipPlayerContainer>
      </ClipSection>
      <ViewNowMobileButton
        to={`/clip/${clip.shareId}`}
        onClick={trackViewNowClick}
      >
        Share
      </ViewNowMobileButton>
      <StyledCommentsContainer>
        <StyledHeaderText textAlign="center">Recent Comments</StyledHeaderText>
        <ClipComments
          clipId={clip?.id}
          disabled={clip?.user?.commentsDisabled}
          variant="top5Widget"
        />
      </StyledCommentsContainer>
    </WidgetContainer>
  );
});

export { Top5Widget };
